


















































import {Vue, Component} from 'vue-property-decorator';

@Component({
  metaInfo() {
    return {title: this.title};
  }
})
export default class CsModifyPopup extends Vue {
  private type: string = '';
  private typeVal: string = '';
  private csNos: any[] = [];
  private csStatusType: any[] = [
    {
      value: 'PROCESSING',
      label: 'CLAIM_CS_LIST_CSSTATUS_TYPE_PROCESSING'
    },
    {
      value: 'DONE',
      label: 'CLAIM_CS_LIST_CSSTATUS_TYPE_DONE'
    }
  ];
  private csType: any[] = [
    {
      value: 'PAY',
      label: 'CLAIM_CS_LIST_CS_TYPE_PAY'
    },
    {
      value: 'PRODUCT',
      label: 'CLAIM_CS_LIST_CS_TYPE_PRODUCT'
    },
    {
      value: 'DELIVERY',
      label: 'CLAIM_CS_LIST_CS_TYPE_DELIVERY'
    },
    {
      value: 'CLAIM',
      label: 'CLAIM_CS_LIST_CS_TYPE_CLAIM'
    },
    {
      value: 'REFUND',
      label: 'CLAIM_CS_LIST_CS_TYPE_REFUND'
    },
    {
      value: 'ETC',
      label: 'CLAIM_CS_LIST_CS_TYPE_ETC'
    }
  ];
  private get title() {
    return this.$t(`CLAIM_CS_LIST_TABLE_LEFT_${this.type.toUpperCase()}_BTN`);
  }
  private get description() {
    const desText = this.$t('CLAIM_CS_LIST_CS_MODIFY_POPUP_DESCRIPTION_BEFORE') as string;
    const csNosLength = this.csNos.length;
    return desText + csNosLength + this.$t(`CLAIM_CS_LIST_CS_MODIFY_POPUP_DESCRIPTION_${this.type.toUpperCase()}`);
  }
  private created() {
    this.type = this.$route.query.type as string;
    this.typeVal = this[this.type][0].value;
    this.csNos = (sessionStorage.getItem('csNos') as string).split(',');
  }
  private save() {
    let obj: any = {
      data: {
        csNos: this.csNos
      }
    };
    obj.data[this.type] = this.typeVal;
    this.$api.putCsAdminBulk(obj).then(() => {
      window.alert(this.$t('CLAIM_CS_LIST_CHANGE_SUCCESS'));
      window.close();
      $(window.opener.location).attr('href', 'javascript:window.csListSearch()');
    });
  }
  private close() {
    window.close();
  }
}
